// extracted by mini-css-extract-plugin
export default {"skip-logic-row":"SkipLogicRow_skip-logic-row__s+Zwx"};